import { routerReducer } from 'react-router-redux'
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore'
import {persistCombineReducers} from "redux-persist";
import storage from "redux-persist/lib/storage";

import wifi from './wifi'
import push from './push'

export const config = {
    key: 'primary',
    storage,
    blacklist: ['firestore', 'firebase', 'routing', 'push']
};

export default persistCombineReducers(config, {
    routing: routerReducer,
    firestore: firestoreReducer,
    firebase: firebaseReducer,

    // Custom reducers
    wifi, push
});


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js